class Pagination extends HTMLElement {
  constructor() {
    super();

    this.triggers = this.querySelectorAll(".js-pagination-trigger");

    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => this.handleClick(trigger));
    });
  }

  handleClick(el) {
    el.classList.add("loading");
    let pageNumber =
        el.getAttribute("data-next-page") || el.getAttribute("data-prev-page"),
      pagePrev = el.getAttribute("data-prev-page"),
      pagePath = window.location.href,
      mainUrl = "",
      sectionToAppend = el
        .closest("[data-pagination-section]")
        .querySelector(".js-product-grid");
    let pageLoaded = pageNumber;
    const pageOffet = el
      .closest("[data-pagination-section]")
      .getAttribute("data-pagination-offset");

    if (pagePath.includes("page=")) {
      var url = new URL(pagePath);
      var search_params = url.searchParams;

      // new value of "id" is set to "101"
      search_params.set("page", pageLoaded);

      // change the search property of the main url
      url.search = search_params.toString();

      // the new url string
      mainUrl = url.toString();
    } else if (pagePath.includes("?")) {
      mainUrl = pagePath + "&page=" + pageLoaded;
    } else {
      mainUrl = pagePath + "?page=" + pageLoaded;
    }

    let sectionId = document
      .querySelector("[data-pagination-section]")
      .getAttribute("data-pagination-section");

    let urlToRequest = mainUrl + "&section_id=" + sectionId;

    fetch(urlToRequest)
      .then((response) => response.text())
      .then((data) => {
        let dataHtml = new DOMParser().parseFromString(data, "text/html"),
          results = dataHtml.querySelector(".js-product-grid").childNodes,
          newPrevButton = dataHtml.querySelector(
            ".js-pagination-ajax-previous"
          ),
          newNextButton = dataHtml.querySelector(".js-pagination-ajax-next"),
          prevButton = document.querySelector(".js-pagination-ajax-previous"),
          nextButton = document.querySelector(".js-pagination-ajax-next");

        if (results) {
          if (pagePrev) {
            while (results.length > 0) {
              sectionToAppend.prepend(results[results.length - 1]);
            }

            if (prevButton && parseInt(pageOffet) >= pageLoaded - 1) {
              prevButton.style.display = "none";
            }

            if (prevButton && newPrevButton) {
              prevButton.innerHTML = newPrevButton.innerHTML;
              if (prevButton.querySelector(".js-pagination-trigger")) {
                prevButton
                  .querySelector(".js-pagination-trigger")
                  .addEventListener("click", () =>
                    this.handleClick(
                      prevButton.querySelector(".js-pagination-trigger")
                    )
                  );
              }
            }
          } else {
            while (results.length > 0) {
              sectionToAppend.append(results[0]);
            }

            if (nextButton && newNextButton) {
              nextButton.innerHTML = newNextButton.innerHTML;
              if (nextButton.querySelector(".js-pagination-trigger")) {
                nextButton
                  .querySelector(".js-pagination-trigger")
                  .addEventListener("click", () =>
                    this.handleClick(
                      nextButton.querySelector(".js-pagination-trigger")
                    )
                  );
              }
            }
          }

          // Events
          window.history.pushState("", "", mainUrl);
        }
      })
      .finally(() => {
        publish(PUB_SUB_EVENTS.pageLoaded);

        const reviewWidgets = document.querySelectorAll("[data-bv-product-id]");
        if (reviewWidgets.length) {
          reviewWidgets.forEach((widget) => {
            widget.setAttribute(
              "data-bv-product-id",
              widget.getAttribute("data-bv-product-id")
            );
          });
        }

        el.classList.remove("loading");
      });
  }
}

customElements.define("infinite-pagination", Pagination);
